import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { Form, Button, TextArea } from 'formik-semantic-ui';
import { TranslationComponent } from '../TranslationComponent';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

export interface PtwQualityRejectModalValues {
  refusalQualityComments: string;
}

interface PtwQualityRejectModalProps {
  i18n: typeof i18n;
  t: typeof i18n.t;
  onSubmit: any;
}

class PPtwQualityRejectModal extends Component<PtwQualityRejectModalProps> {
  state: { open: boolean } = {
    open: false,
  };

  toggleOpen = (open: boolean) => {
    this.setState({ open });
  };

  render() {
    const { t } = this.props;

    return (
      <Modal
        open={this.state.open}
        onClose={() => this.toggleOpen(false)}
        trigger={
          <Button negative onClick={() => this.toggleOpen(true)}>
            <TranslationComponent stringKey={'Reject'} />
          </Button>
        }
      >
        <Modal.Header>
          <TranslationComponent stringKey={'Reject'} />
        </Modal.Header>
        <Modal.Content>
          <Form initialValues={{ refusalQualityComments: '' }} onSubmit={this.props.onSubmit}>
            <TextArea label={t('Comment')} name="refusalQualityComments" />
            <Button onClick={() => this.toggleOpen(false)}>
              <TranslationComponent stringKey={'Cancel'} />
            </Button>
            <Button.Submit>
              <TranslationComponent stringKey={'Confirm'} />
            </Button.Submit>
          </Form>
        </Modal.Content>
      </Modal>
    );
  }
}

export const PtwQualityRejectModal = withTranslation()(PPtwQualityRejectModal);
